import { Card, Descriptions, Tag, Space } from 'antd';

interface EventOverviewProps {
  event: any;
}

export default function EventOverview({ event }: EventOverviewProps) {
  return (
    <div>
      <Card title="Event Information">
        <Descriptions column={2} bordered>
          <Descriptions.Item label="Event Name">{event.name}</Descriptions.Item>
          <Descriptions.Item label="Slug">{event.slug}</Descriptions.Item>
          <Descriptions.Item label="Location">{event.location}</Descriptions.Item>
          <Descriptions.Item label="Type">
            <Tag color="blue">{event.eventType?.toUpperCase()}</Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Start Date">
            {new Date(event.startDate).toLocaleDateString()}
          </Descriptions.Item>
          <Descriptions.Item label="End Date">
            {new Date(event.endDate).toLocaleDateString()}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={event.isActive ? 'green' : 'red'}>
              {event.isActive ? 'Active' : 'Inactive'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Email Template">
            {event.emailTemplate ? (
              <Tag color="blue">{event.emailTemplate.name}</Tag>
            ) : (
              <Tag>None</Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Description" span={2}>
            {event.description || 'No description'}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card title="Statistics" style={{ marginTop: 16 }}>
        <Space size="large">
          <div>
            <div style={{ fontSize: 24, fontWeight: 'bold' }}>
              {event._count.feedbacks + event._count.simpleFeedbacks}
            </div>
            <div style={{ color: '#888' }}>Total Responses</div>
          </div>
          <div>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#8b5cf6' }}>
              {event._count.feedbacks}
            </div>
            <div style={{ color: '#888' }}>Comprehensive</div>
          </div>
          <div>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#059669' }}>
              {event._count.simpleFeedbacks}
            </div>
            <div style={{ color: '#888' }}>Simple</div>
          </div>
          <div>
            <div style={{ fontSize: 24, fontWeight: 'bold', color: '#ec4899' }}>
              {event._count.magicLinks || 0}
            </div>
            <div style={{ color: '#888' }}>Magic Links</div>
          </div>
        </Space>
      </Card>
    </div>
  );
}
